module.exports = "#container {\n  padding: 15px;\n}"